<template>
  <report-container :actions="actions">
    <template v-slot:report-modals>
      <creatives-discrepancy-modal />
    </template>
  </report-container>
</template>

<script>
import mixin from 'src/utils/mixin'

export default {
  name: 'Discrepancy',
  components: {
    CreativesDiscrepancyModal: () => import('../components/modals/CreativesDiscrepancyModal'),
    ReportContainer: () => import('src/report/components/ReportContainer'),
  },
  mixins: [mixin],
  data() {
    return {
      actions: [
        {
          event: 'delivery/openTabToLineItem',
          name: 'Go to Line Item',
        },
        {
          event: 'delivery/openTabToOrder',
          name: 'Go to Order',
        },
        {
          event: 'delivery/showCreativesDiscrepancyModal',
          name: 'Creatives Discrepancy',
        },
      ],
    }
  },
}
</script>
